import { Box, Button, customStyled } from '@mafc/trolly';

export const RoundCornerButton = customStyled(Button)(({ theme: { fontWeights } }) => ({
  width: '100%',
  height: '48px',
  fontWeight: fontWeights[8],
  borderRadius: '12px',
  textTransform: 'none',
}));

export const DriverTips = customStyled(Box)(({ theme: { space } }) => ({
  marginBottom: space[4],
}));

export const TipButton = customStyled.label(({ theme: { colors, fontWeights, fontSizes } }) => ({
  backgroundColor: colors.white,
  borderRadius: '48px',
  padding: '14px 12px',
  color: colors.black,
  fontWeight: fontWeights[8],
  fontSize: fontSizes[3],
  maxHeight: '48px',
  textAlign: 'center',
  width: '95px',
  display: 'inline-block',
  cursor: 'pointer',
}));

export const ComingSoon = customStyled(Box)(({ theme: { colors, fontSizes, radii } }) => ({
  backgroundColor: colors.babyBlue,
  borderRadius: radii[3],
  padding: '14px 12px',
  color: colors.black,
  fontSize: fontSizes[2],
}));

export const TipButtonWrapper = customStyled(Box)`
  position: relative;
  margin-right: ${props => props.theme.space[2]}px;
  [type="radio"]:checked + label {
    background-color: ${props => props.theme.colors.babyBlue};
    color: ${props => props.theme.colors.blue};
  }
`;

export const Radio = customStyled.input`
    &:checked, &:not(:checked) {
        position: absolute;
        left: -9999px;
        opacity: 0
    }
`;
